import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "branch-card" }
const _hoisted_2 = { class: "branch-title-text" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.content.header || $setup.content.title)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['branch-body',$setup.isPC ? 'branch-bubble':'branch-bubble-h5'])
        }, [
          _createVNode(_component_Icon, {
            src: $setup.iconQuestion,
            class: "branch-title-icon"
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_2, _toDisplayString($setup.content.header || $setup.content.title), 1)
        ], 2))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.content.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(['branch-body',$setup.isPC ? 'branch-bubble':'branch-bubble-h5','branch-item',$setup.isSelected ? 'branch-item-selected' : '', item.content ? '' : 'warning-item']),
        style: _normalizeStyle({ borderWidth: $setup.content.header ? '1px 0 0px 0' : '' }),
        onClick: ($event: any) => ($setup.handleContentListItemClick(item))
      }, _toDisplayString(item.content || $setup.TUITranslateService.t('AIDesk.分支选项异常')), 15, _hoisted_3))
    }), 128))
  ]))
}